// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"styles_skeleton__2RQA-"};